/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlEntityStatsSurfaceCategory
 */
export interface ControlEntityStatsSurfaceCategory {
    /**
     * 
     * @type {string}
     * @memberof ControlEntityStatsSurfaceCategory
     */
    key?: string;
    /**
     * 
     * @type {number}
     * @memberof ControlEntityStatsSurfaceCategory
     */
    value?: number;
}

/**
 * Check if a given object implements the ControlEntityStatsSurfaceCategory interface.
 */
export function instanceOfControlEntityStatsSurfaceCategory(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ControlEntityStatsSurfaceCategoryFromJSON(json: any): ControlEntityStatsSurfaceCategory {
    return ControlEntityStatsSurfaceCategoryFromJSONTyped(json, false);
}

export function ControlEntityStatsSurfaceCategoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlEntityStatsSurfaceCategory {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'key': !exists(json, 'key') ? undefined : json['key'],
        'value': !exists(json, 'value') ? undefined : json['value'],
    };
}

export function ControlEntityStatsSurfaceCategoryToJSON(value?: ControlEntityStatsSurfaceCategory | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'key': value.key,
        'value': value.value,
    };
}

